import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";
import ChartTypes from "@/components/ChartTypes.tsx";
import DashboardDataGenerator from "../../DashboardDataGenerator";

@Component
export default class ReadingOverall extends Vue {
  @Prop({ default: null }) data: any; // data to inject into chart

  private dataGen!: DashboardDataGenerator;
  private refId = "balaReading";
  private chartId = "bala-reading";
  private arrAvg: any;

  private selection: string = "overall"; // do not change, linked to db
  private descriptions: any; // dashboard descriptions

  created() {
    this.selection = this.data.selection;
    this.descriptions = this.$store.getters.teacherDashboard.bala.descriptions;
  }

  private chartData = {
    type: "horizontalBar",
    labels: [],
    data: { labels: [], datasets: [] },
    options: {
      responsive: true,
      barValueSpacing: 20,
      lineTension: 1,
      // title: {
      // display: true,
      // text: 'RIP',
      // },
      legend: {
        display: false
      },
      scales: {
        yAxes: [
          {
            id: "y-axis-0",
            scaleLabel: {
              display: false,
              labelString: "Criterion"
            },
            ticks: {
              beginAtZero: true,
              padding: 25
            }
          }
        ],
        xAxes: [
          {
            id: "x-axis-0",
            scaleLabel: {
              display: true,
              labelString: "Percentage of Questions Answered Correctly (%)"
            },
            ticks: {
              beginAtZero: true,
              suggestedMax: 100
            }
          }
        ]
      }
    }
  };

  private getDataset(data: any) {
    let labels: any = [];
    let score: any = [];
    let backgroundColor: any = [];

    let dashboard = this.descriptions.dashboards[this.selection];
    Object.keys(dashboard.datapoints).forEach(key => {
      let label = dashboard.datapoints[key].label;
      let _score = data[key] !== undefined ? data[key] : undefined;
      // let _averages = data[key] !== undefined ? data[key].mean : undefined;
      let color = dashboard.datapoints[key].color;

      if (_score != undefined) {
        labels.push(label);
        score.push(_score);
        // averages.push(_averages);
        backgroundColor.push(color);
      }
    });

    let dataset = [
      {
        backgroundColor: backgroundColor,
        data: score
      }
    ];

    return {
      labels: labels,
      score: score,
      dataset: dataset,
      color: backgroundColor
    };
  }

  async mounted() {
    const data_unf: any = this.getDataset(this.data);

    (this.chartData.data.datasets as any) = data_unf.dataset;
    (this.chartData.data.labels as any) = data_unf.labels;
    (this.$refs[this.refId] as any).forceRefresh();
  }

  render(h: CreateElement) {
    return (
      <v-card>
        <v-card-title class="mx-auto text-center">
          {this.descriptions["dashboards"][this.selection].name}
        </v-card-title>
        <v-card-text>
          <ChartTypes
            chartId={this.chartId}
            chartData={this.chartData}
            ref={this.refId}
          ></ChartTypes>
          <br />
          {/* <v-container style={{height: "150px", overflow: "scroll"}}>
            The questions evaluating inferential reasoning require students to make inferences based on text titles, using their background knowledge, reasoning the author's intent, or predicting what is likely or not likely to happen as a result. An example of a making inferences question is: <i>"What would like happen if there were no bats?"</i>
          </v-container> */}
        </v-card-text>
      </v-card>
    );
  }
}

const component = ReadingOverall;
